import React, { useEffect } from "react";
import Amount from "./components/Amount";
import Description from "./components/Description";
import TransferStatus from "./components/TransferStatus";
import { t } from "../../../utils/i18n";

const Body = ({ transfers, canViewCardTransactionDetails }) => {
  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  });

  const getDescriptionMeta = (transfer) => {
    if (transfer.completed_at) {
      return (
        <div className="font-0_85">{t("account.activities.completed", { date: transfer.completed_at })}</div>
      );
    }

    return <div className="font-0_85">{t("account.activities.created", { date: transfer.created_at })}</div>;
  };

  const getExpiredMeta = (transfer) => {
    if (transfer.expires_at && transfer.is_expired) {
      return <div className="font-0_85">{t("account.activities.expired_on", { date: transfer.expires_at })}</div>;
    }

    return <></>;
  };

  const handleRowClick = (e, transfer) => {
    if (!e.target.closest("td:last-child")) {
      window.location = transferLink(transfer);
    }
  };

  const transferLink = (transfer) => {
    if (transfer.is_card_load) {
      return transfer.card_detail_id && transfer.card_sender_ref
        ? `/cards/${transfer.card_detail_id}/card_loads/${transfer.card_sender_ref}`
        : `/cards/requests`;
    }

    if (transfer.is_card_request) {
      return transfer.card_sender_ref
        ? `/cards/requests/${transfer.card_sender_ref}`
        : "/cards/requests";
    }

    return `/crypto_transfers/${transfer.id}`;
  };

  return (
    <tbody className="table-body">
      {transfers.map((transfer, i) => (
        <tr
          key={transfer.id}
          className="cursor-pointer"
          onClick={(e) => handleRowClick(e, transfer)}
        >
          <td className="pl-2 ml-1">
            <div className="font-weight-bold d-flex justify-content-between">
              <span className="show-from-tab">{t("account.activities.date")}:</span>
              <span>{transfer.date_created}</span>
            </div>
          </td>
          <td>
            <div className="font-weight-bold d-flex justify-content-between">
              <span className="show-from-tab">{t("account.activities.amount")}:</span>
              <span>
                <Amount transfer={transfer} />
              </span>
            </div>
          </td>
          <td>
            <div className="font-weight-bold d-flex justify-content-between">
              <span className="show-from-tab">{t("account.activities.type")}:</span>
              <span className="activity-type-text">
                {transfer.transfer_type}
              </span>
            </div>
          </td>
          <td className="expandable-description">
            <div className="font-weight-bold d-flex justify-content-between">
              <span className="show-from-tab">{t("account.activities.description")}:</span>
              <span className="description-mobileview">
                <Description
                  transfer={transfer}
                  canViewCardTransactionDetails={canViewCardTransactionDetails}
                />
                <div className="collapse" id={`collapseDescription${i}`}>
                  {getDescriptionMeta(transfer)}
                  {getExpiredMeta(transfer)}
                </div>
              </span>
            </div>
          </td>
          <td className={transfer.active_class_by_status}>
            <div className="font-weight-bold d-flex justify-content-between">
              <span className="show-from-tab">{t("account.activities.status")}:</span>
              <span>
                <TransferStatus transfer={transfer} />
              </span>
            </div>
          </td>
          <td className="actions trash">
            <span>
              <a className="btn-link" href={transferLink(transfer)}>
                {t("account.activities.view")} <i className="fa fa-arrow-right"></i>
              </a>
            </span>
          </td>
        </tr>
      ))}
      {transfers.length === 0 && (
        <tr>
          <td colSpan={8} className="text-center">
            {t("account.activities.empty")}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default Body;
